import { useTheme } from "next-themes"

/**
 * Thin wrapper around next-themes useTheme for convenience.
 * Provides theme, setTheme, resolvedTheme, and a cycleTheme helper.
 * 
 * @returns {{ theme: string, setTheme: (theme: string) => void, resolvedTheme: string, cycleTheme: () => void }}
 */
export default function useThemeMode() {
    const { theme, setTheme, resolvedTheme } = useTheme()

    /** Cycles through system → light → dark → system */
    function cycleTheme() {
        if (theme === "system") setTheme("light")
        else if (theme === "light") setTheme("dark")
        else setTheme("system")
    }

    return { theme, setTheme, resolvedTheme, cycleTheme }
}
